<template>
  <div @keyup="handleKeyUp">
    <b-form-file v-show="mode==='preview'" ref="tmpfile" v-model="file" placeholder="請先選擇要處理的圖片" @change.native="loadImage" accept=".jpg, .png, .gif, .svg"></b-form-file>
    <div v-show="mode!=='preview'">
      <b-row>
        <label class="col-md-3 mt-1">下載檔名(副檔名依選擇)</label>
        <b-form-input class="col-md-5 mb-1" type="text" v-model="targetFileName" ></b-form-input>
      </b-row>
    </div>
    <div v-if="fileUrl!==''">
      <b-button @click="changeMode('cropping')" v-if="mode==='preview'" style="margin-right: 20px;">裁切</b-button>
      <b-button @click="changeMode('resizing')" v-if="mode==='preview'" style="margin-right: 20px;">調整尺寸</b-button>
      <b-button @click="changeMode('preview')" v-if="mode!=='preview'" style="margin-right: 20px;">重選處理圖片</b-button>
      <b-button @click="zoom(0.1)" v-if="mode==='cropping' && cropSetting.cropPreview===false" style="margin-right: 20px;">大</b-button>
      <b-button @click="zoom(-0.1)" v-if="mode==='cropping' && cropSetting.cropPreview===false" style="margin-right: 20px;">小</b-button>
      <b-button @click="rotate" v-if="mode==='cropping' && cropSetting.cropPreview===false" style="margin-right: 20px;">轉</b-button>
      
      <!--<b-button @click="move(5,0)" v-if="mode==='cropping'" style="margin-right: 40px;">左</b-button>
      <b-button @click="move(-5,0)" v-if="mode==='cropping'" style="margin-right: 40px;">右</b-button>
      <b-button @click="move(0,5)" v-if="mode==='cropping'" style="margin-right: 40px;">下</b-button>
      <b-button @click="move(0,-5)" v-if="mode==='cropping'" style="margin-right: 40px;">上</b-button>-->
      <b-button @click="cropImage" v-if="mode==='cropping' && !cropSetting.cropPreview" style="margin-right: 20px;">裁下去</b-button>
      <b-button @click="backCropping" v-if="mode==='cropping' && cropSetting.cropPreview" class="col-md-5" >回去重裁</b-button>
      <b-button v-if="mode==='cropping' && checkMobile() && !cropSetting.cropPreview" @click="showCropTool = !showCropTool">設定</b-button>
    </div>
    <div v-show="mode==='preview' && fileUrl!==''" :style="previewStyle">
      <img ref="loadedImg" style="width:100%;height:100%;" :src="fileUrl"/>
      <span v-if="file">{{humanFileSize(file.size)}}</span>
    </div>
    <div v-if="mode==='cropping'">
      <div class="mx-auto">
        <b-row v-show="!checkMobile() || showCropTool" class="my-1" v-if="cropSetting.cropPreview===false">
          <span class="col-md-1 mt-1" v-b-tooltip.hover title="裁剪目標區尺寸,按enter重設才生效">產出</span>
          <b-input-group class="col-md-2 px-0" prepend="寬" append="px">
            <b-form-input class="px-0" type="number" v-model="cropSetting.croppedBoxWidth" placeholder="寬度px" @change="setCropBox($event,'w', false)"></b-form-input>  
          </b-input-group>
          <b-input-group class="col-md-2 px-0 ml-1" prepend="高" append="px">
            <b-form-input class="px-0" type="number" v-model="cropSetting.croppedBoxHeight" placeholder="高度px" @change="setCropBox($event,'h', false)"></b-form-input>  
          </b-input-group>
          <span class="col-md-1 mt-1" v-b-tooltip.hover title="裁剪編輯區外框尺寸,按enter重設才生效">外框</span>
          <b-input-group class="col-md-2 px-0" prepend="寬" append="px">
            <b-form-input class="px-0" type="number" v-model="cropSetting.tmpCropFrameWidth" placeholder="寬度px" @change="setCropFrame(false)"></b-form-input>  
          </b-input-group>
          <b-input-group class="col-md-2 px-0 ml-1" prepend="高" append="px">
            <b-form-input class="px-0" type="number" v-model="cropSetting.tmpCropFrameHeight" placeholder="高度px" @change="setCropFrame(false)"></b-form-input>  
          </b-input-group>
          
        </b-row>
        <b-row v-show="cropSetting.cropPreview">
          <span class="col-md-2">畫質高低(低到高)</span>'
          <b-form-input class="col-md-4" type="range" min=50 max=100 step=1 v-model="compressionRate" @change="cropImage('resize')"></b-form-input>
          <b-form-checkbox class="col-md-2 ml-2" v-model="cropSetting.circleImg" v-b-tooltip.hover title="注意：預估檔案大小仍以矩形計算(實際大小會縮小裁掉的部分),若裁減框不是正方形會是橢圓形">裁剪為圓形</b-form-checkbox>
          <b-form-select class="col-md-2" v-model="targetFileType" :options="imgTypes"></b-form-select>
        </b-row>
      </div>
      <transition name="fade" mode="out-in" appear>
      <div class="mx-auto" :style="cropContainerStyle">
        <vue-cropper
          ref="cropper"
          :src="fileUrl"
          alt="Source Image"
          :guides="true"
          :view-mode="2"
          dragMode="move"
          :responsive="false"
          :cropBoxResizable="false"
        >
        </vue-cropper>
      </div>
      </transition>
      <transition name="fade2" mode="out-in" appear>
      <div v-show="cropSetting.croppedImg && cropSetting.cropPreview" class="mx-auto" :style="croppedStyle">
        <img ref="imgTarget" :src="cropSetting.croppedImg" :style="targetImgStyle"/>
        <span class="my-auto" >{{humanFileSize(Math.round((cropSetting.croppedImg.length-22)*3/4))}}</span>
        <b-button class="my-auto" @click="saveCropImage" v-if="mode==='cropping' && cropSetting.croppedImg !== ''" >下載</b-button>
      </div>
      </transition>
    </div>
    <div v-if="mode==='resizing'">
      <b-row>
        <span class="col-md-3">畫質高低(低到高)</span>
        <b-form-input class="col-md-2" type="range" min=50 max=90 step=1 v-model="compressionRate" @change="redrawImage"></b-form-input>
        <span class="col-1"/>
        <b-form-select class="col-md-2" v-model="targetFileType" :options="imgTypes"></b-form-select>
        <b-form-checkbox class="col-md-3 mt-1 ml-1" v-model="displayOutputSize">調整輸出尺寸</b-form-checkbox>
      </b-row>
      <b-row v-show="displayOutputSize">
        <span class="col-md-3 mt-1">輸出尺寸寬高</span>
        <b-input-group class="col-md-3 px-0" prepend="寬" append="px">
          <b-form-input class="px-0" type="number" v-model="resizeTargetWidth" @change="redrawImage" v-b-tooltip.hover title="指定寬度後按Enter,高度依比例計算,需要變形請用裁圖"></b-form-input>  
        </b-input-group>
        <span class="col-1" />
        <b-input-group class="col-md-3 px-0" prepend="高" append="px">
          <b-form-input disabled class="px-0" type="number" v-model="resizeTargetHeight"></b-form-input>  
        </b-input-group>
      </b-row>
      <span v-if="resizedImg!==''">{{humanFileSize(Math.round((resizedImg.length-22)*3/4))}}</span>
      <b-button @click="saveResizeImage" class="col-md-2">下載</b-button>
      <div v-if="resizedImg!==''" :style="previewStyle">
        <img ref="imgTarget" :src="resizedImg" :style="targetImgStyle"/>
      </div>
    </div>
  </div>
</template>

<script>

import VueCropper from 'vue-cropperjs'
import saveAs from 'file-saver'

export default {
  name: 'ImageWork',
  components: {
    VueCropper
  },
  props: {
    'maxWidth':{
      type:Number,
      default: 640,
    },
    'maxHeight':{
      type:Number,
      default: 480,
    }
  },
  data: function () {
    return {
      mode: "preview", // preview/cropping/resizing
      file: null,
      fileUrl: "",
      // 讀取圖片的寬高來提供computed style有時間差所以需要變數保存
      nWidth:null,
      nHeight:null,
      targetFileName: "處理結果",
      compressionRate: 75,
      targetFileType: "image/jpeg",
      imgTypes:[
        {value:"image/jpeg",text:"jpeg(去背X)"},
        {value:"image/png",text:"png(壓縮X)"},
        {value:"image/gif",text:"gif(壓縮X)"},
      ],
      showCropTool: false,
      cropSetting:{
        croppedImg: "",
        cropFrameWidth:640,
        cropFrameHeight:480,
        tmpCropFrameWidth:640,
        tmpCropFrameHeight:480,
        croppedBoxWidth:240,
        croppedBoxHeight:240,
        opacity:1,
        circleImg:false,
        cropPreview: false,
      },
      resizedImg: "",
      displayOutputSize:false,
      resizeTargetWidth:0,
      resizeTargetHeight:0,
    }
  },
  methods: {
    reset() {
      this.mode = 'preview'
      this.$refs.tmpfile.reset()
      // 可以用下面兩個指令做到一樣效果(裡面的input的value變成空字串)
      // this.$refs.tmpfile.$refs.input.value = ''
      // this.$refs.tmpfile.selectedFile = null
      this.fileUrl = ""
   },
    changeMode(mode) {
      // v-if的關係要先讓mode改變以render組件後面的$refs才有東西
      this.mode = mode
      if (mode === 'cropping') {
        setTimeout(() => {
          if (this.fileUrl) {
            this.$refs.cropper.replace(this.fileUrl)
            setTimeout(() => {
              this.$refs.cropper.setCropBoxData({width:this.cropSetting.croppedBoxWidth,height:this.cropSetting.croppedBoxHeight})
              // 去副檔名,因為下載時指定會自帶副檔名
              this.targetFileName = '(輸出)'+this.file.name.substring(0, this.file.name.lastIndexOf('.'))
              // 不能對編輯區依比例計算限制預設大小...會導致母圖被裁掉一部分遺失救不回來Q_Q
              let ratio = this.nWidth/this.nHeight
              if (ratio > 1) {
                this.cropSetting.tmpCropFrameWidth = this.nWidth>this.maxWidth?this.maxWidth:this.nWidth
                this.cropSetting.tmpCropFrameHeight = this.nWidth>this.maxWidth?(this.maxWidth)/ratio:(this.nWidth/ratio)
              }
              else {
                this.cropSetting.tmpCropFrameWidth =  this.nHeight>this.maxHeight?(this.maxHeight*ratio):(this.nHeight*ratio)
                this.cropSetting.tmpCropFrameHeight = this.nHeight>this.maxHeight?this.maxHeight:this.nHeight
              }
              this.cropSetting.croppedBoxWidth = this.cropSetting.tmpCropFrameWidth/2
              this.cropSetting.croppedBoxHeight = this.cropSetting.tmpCropFrameHeight/2
              this.setCropFrame(true)
            }, 0);
          }  
        }, 0);        
      }
      else if (mode === 'preview') {
        if (this.cropSetting.cropPreview) {
          this.backCropping()
        }
      }
      else if (mode === 'resizing') {
        this.targetFileName = '(壓縮)'+this.file.name.substring(0, this.file.name.lastIndexOf('.'))
        // this.resizedImg = this.fileUrl
        this.resizeImage()
      }
    },
    saveCropImage () {
      let data = this.cropSetting.croppedImg
      if (this.cropSetting.croppedImg !== '' && this.cropSetting.circleImg) {
        // 圓形匯出前要用Canvus重畫一次才能變圓的裁掉多餘部分減少尺寸
        let canvas = document.createElement('canvas')
        // 這很重要,沒做的話canvas的尺寸會是100/100怎麼畫都不對
        canvas.width = this.cropSetting.croppedBoxWidth
        canvas.height = this.cropSetting.croppedBoxHeight
        let ctx = canvas.getContext('2d')
        ctx.drawImage(this.$refs.imgTarget, 0, 0, this.cropSetting.croppedBoxWidth, this.cropSetting.croppedBoxHeight)
        //ctx.fillStyle = 'rgba(255, 255, 255, '+this.cropSetting.opacity+')'
        
        ctx.globalCompositeOperation = 'destination-in'
        ctx.beginPath();
        ctx.arc(this.cropSetting.croppedBoxWidth/2, this.cropSetting.croppedBoxHeight/2 , this.cropSetting.croppedBoxWidth/2 , 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();
        data = canvas.toDataURL(this.targetFileType,parseInt(this.compressionRate)/100)
      }
      // 要轉成blob用file-saver存檔...否則產生的圖片檔案太大時就無法存檔了(2MB in Chrome)
      let blobData = this.dataURItoBlob(data)
      saveAs(blobData,this.targetFileName)
      
    },
    saveResizeImage () {
      // 要轉成blob用file-saver存檔...否則產生的圖片檔案太大時就無法存檔了(2MB in Chrome)
      let blobData = this.dataURItoBlob(this.resizedImg)
      saveAs(blobData,this.targetFileName)
      
    },
    dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(',')[0].indexOf('base64') >= 0)
          byteString = atob(dataURI.split(',')[1]);
      else
          byteString = unescape(dataURI.split(',')[1]);

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], {type:mimeString});
    },
    loadImage () {
      // 不至少settimeout 0的話this.file會抓不到剛更新的值,而是前一次的值
      setTimeout(() => {
        if (this.file) {
          let reader = new FileReader()
          reader.readAsDataURL(this.file)
          reader.onload = (_file) => {
            this.fileUrl = _file.target.result
            setTimeout(() => {
              // 預設檢視尺寸
              this.nWidth = this.$refs.loadedImg.naturalWidth
              this.nHeight = this.$refs.loadedImg.naturalHeight
            }, 100);
          }
        }
        else {
          this.fileUrl = ""
        }        
      }, 0);

    },
    setCropBox (event, axis, initBoxPos) {
      if (axis === 'w' && event > this.cropSetting.cropFrameWidth) {
        this.cropSetting.croppedBoxWidth = this.cropSetting.cropFrameWidth
      }
      if (axis === 'h' && event > this.cropSetting.cropFrameHeight) {
        this.cropSetting.croppedBoxHeight = this.cropSetting.cropFrameHeight
      }
      let setting = {
        width:parseInt(this.cropSetting.croppedBoxWidth),
        height:parseInt(this.cropSetting.croppedBoxHeight)
      }
      if (initBoxPos) {
        setting.top = parseInt(this.cropSetting.cropFrameHeight/4)
        setting.left = parseInt(this.cropSetting.cropFrameWidth/4)
      }
      this.$refs.cropper.setCropBoxData(setting)
    },
    setCropFrame (initBoxPos) {
      this.cropSetting.tmpCropFrameWidth = this.cropSetting.tmpCropFrameWidth > this.cropSetting.croppedBoxWidth?this.cropSetting.tmpCropFrameWidth:this.cropSetting.croppedBoxWidth
      this.cropSetting.tmpCropFrameHeight = this.cropSetting.tmpCropFrameHeight > this.cropSetting.croppedBoxHeight?this.cropSetting.tmpCropFrameHeight:this.cropSetting.croppedBoxHeight
      this.cropSetting.cropFrameWidth = this.cropSetting.tmpCropFrameWidth
      this.cropSetting.cropFrameHeight = this.cropSetting.tmpCropFrameHeight
      this.$refs.cropper.replace(this.fileUrl)
      setTimeout(() => {
        this.setCropBox(null, null, initBoxPos)
      }, 50);
    },
    resizeImage () {
      // 用參數重新產生dataurl
      let that = this
      let img = new Image;
      img.src = this.fileUrl
      let canvas = document.createElement('canvas')
      canvas.width = this.$refs.loadedImg.naturalWidth
      canvas.height = this.$refs.loadedImg.naturalHeight
      let ratio = this.$refs.loadedImg.naturalWidth/this.$refs.loadedImg.naturalHeight
      this.resizeTargetWidth = this.$refs.loadedImg.naturalWidth
      this.resizeTargetHeight = this.$refs.loadedImg.naturalHeight
      
      var ctx = canvas.getContext('2d');
      img.onload = function(){
        ctx.drawImage(img,0,0) // Or at whatever offset you like
        setTimeout(() => {
          that.resizedImg = canvas.toDataURL(that.targetFileType,parseInt(that.compressionRate)/100)
        }, 500);
      };
    },
    redrawImage () {
      let ratio = this.$refs.loadedImg.naturalWidth/this.$refs.loadedImg.naturalHeight
      this.resizeTargetHeight = Math.round(this.resizeTargetWidth/ratio)
      let that = this
      let img = new Image;
      img.src = this.fileUrl
      let canvas = document.createElement('canvas')
      canvas.width = Number(this.resizeTargetWidth)
      canvas.height = Number(this.resizeTargetHeight)
      
      var ctx = canvas.getContext('2d');
      img.onload = function(){
        ctx.drawImage(img,0,0,canvas.width,canvas.height); // Or at whatever offset you like
        setTimeout(() => {
          that.resizedImg = canvas.toDataURL(that.targetFileType,parseInt(that.compressionRate)/100)
        }, 500);
      };
    },
    cropImage (action='crop') {
      if (action==='resize' && this.cropSetting.cropPreview === false ) {
        return
      }
      let theimg = this.$refs.cropper.getCroppedCanvas()
      this.cropSetting.croppedImg = theimg.toDataURL(this.targetFileType,parseInt(this.compressionRate)/100)
      this.cropSetting.cropPreview = true
    },
    backCropping () {
      this.cropSetting.croppedImg = ""
      this.targetFileType = "image/jpeg"
      //回預覽時不用重設裁剪框
      if (this.mode === 'cropping') {
        this.setCropFrame(true)
      }
      this.cropSetting.cropPreview = false
    },
    circleCropImage () {
      this.cropSetting.circleImg = !this.cropSetting.circleImg
    },
    rotate () {
      this.$refs.cropper.rotate(90)
    },
    move (left, top) {
      this.$refs.cropper.move(left,top)
    },
    handleKeyUp(evt) {
      if (!this.fileUrl) {
        return
      }
      switch (evt.which) {
        case 37:
          this.$refs.cropper.move(5,0)
          break;
        case 38:
          this.$refs.cropper.move(0,-5)
          break;
        case 39:
          this.$refs.cropper.move(-5,0)
          break;
        case 40:
          this.$refs.cropper.move(0,5)
          break;
      }
    },
    zoom (lv) {
      this.$refs.cropper.relativeZoom(lv)
    },
  },
  computed: {
    previewStyle: {
      cache: false,
      get () {
        let style_str = ""
        if (this.nWidth > 0) {
            if (this.$refs.loadedImg.naturalWidth > this.$refs.loadedImg.naturalHeight) {
              style_str = "margin-left:auto;margin-right:auto;width:"+this.maxWidth+"px;height:"+(this.maxWidth*(this.nHeight/this.nWidth))+"px;"
            }
            else {
              style_str = "margin-left:auto;margin-right:auto;height:"+this.maxHeight+"px;width:"+(this.maxHeight*(this.nWidth/this.nHeight))+"px;"
            }
        }
        return style_str
      }
    },
    cropContainerStyle: {
      cache: true,
      get () {
        return (this.cropSetting.cropPreview?"display:none;":"")+"overflow:scroll;width:"+this.cropSetting.cropFrameWidth+"px;height:"+this.cropSetting.cropFrameHeight+"px;"
      }
    },
    croppedStyle: {
      cache: false,
      get () {
        return "display:flex;width:"+this.cropSetting.croppedBoxWidth+"px;height:"+this.cropSetting.croppedBoxHeight+"px;"
      }
    },
    targetImgStyle: {
      cache: false,
      get () {
        return "width:100%;height:100%;top:0px;left:0px;position:relative;"+(this.cropSetting.circleImg?"border-radius:50%;":"")
      }
    },
  },
  watch: {
    'targetFileType'(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.mode === 'cropping') {
          this.cropImage('resize')
        }
        else if (this.mode === 'resizing') {
          this.resizeImage()
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.px-0 {
  text-align: right;
}
</style>
